// Components
import Checkbox from 'components/form/checkbox'
import Field from 'components/form/field'
import Select from 'components/form/select-input'
import { TextInput } from 'components/form/text-input'
// Modules
import { DI } from 'modules'
import PaymentBlock, {
  PaymentBlockFields,
} from 'pages/business/components/payment-block'
import * as React from 'react'

const PaymentBilling = ({
  common,
  form,
  onValidateForm,
  validators,
  user,
  geodata,
  onVATChange,
}) => {
  const { strings } = common
  const { company } = form?.user || {}
  const { isSignedIn } = user

  const prefix = 'page.billing'
  const formPrefix = `${prefix}.form`
  const isDisableField = user.agreements.payload.some(
    agr => agr.status === 'active'
  )

  return (
    <PaymentBlock
      text={strings[`${prefix}.information.text`]}
      title={strings[`${prefix}.information.title`]}
    >
      <PaymentBlockFields>
        <Field label={strings[`${formPrefix}.first_name`]}>
          <TextInput
            isLatin
            isRequired
            name="user[company][first_name]"
            onValidateForm={onValidateForm}
            reactOnChange
            value={company?.first_name}
            disabled={isDisableField}
          />
        </Field>

        <Field label={strings[`${formPrefix}.last_name`]}>
          <TextInput
            isLatin
            isRequired
            name="user[company][last_name]"
            onValidateForm={onValidateForm}
            reactOnChange
            value={company?.last_name}
            disabled={isDisableField}
          />
        </Field>

        {(user?.companyCountry.isEU || !isSignedIn) && (
          <Field label={strings[`${formPrefix}.vat`]}>
            <input
              name="user[company][vat_id]"
              type="hidden"
              value={company?.vat_id}
            />

            <TextInput
              disabled={company?.has_no_vat}
              isRequired={!company?.has_no_vat}
              name="user[company][vat_id]"
              onChange={onVATChange}
              onValidateForm={onValidateForm}
              validators={validators}
              value={company?.has_no_vat ? '' : company?.vat_id}
            />

            <Checkbox
              checked={company?.has_no_vat}
              name="user[company][has_no_vat]"
              uncheckedValue={false}
              value
            >
              {strings[`${formPrefix}.dont_have_vat`]}
            </Checkbox>
          </Field>
        )}

        <Field label={strings[`${formPrefix}.country`]}>
          {user?.companyCountry?.name ? (
            <span className="d-field__text">{user?.companyCountry?.name}</span>
          ) : (
            <Select
              wrapSelect
              items={geodata.countries.payload}
              getTitle={item => item.name}
              getValue={item => item.id}
              name="user[company][country_id]"
              placeholder={strings[`${formPrefix}.country`]}
              value={Number(form.user.company?.country_id || user?.country?.id)}
              onValidateForm={onValidateForm}
              modificator="sign-in"
              notSelected
              isRequired
              isInput
            />
          )}
        </Field>

        <Field label={strings[`${formPrefix}.addr_1`]}>
          <TextInput
            isLatin
            isRequired
            name="user[company][billing_address1]"
            onValidateForm={onValidateForm}
            reactOnChange
            value={company?.billing_address1}
            disabled={isDisableField}
          />
        </Field>

        <Field label={strings[`${formPrefix}.zip`]}>
          <TextInput
            isLatin
            isRequired
            name="user[company][postal_code]"
            onValidateForm={onValidateForm}
            value={company?.postal_code}
            width="140"
            disabled={isDisableField}
          />
        </Field>

        <Field label={strings[`${formPrefix}.city`]}>
          <TextInput
            isLatin
            isRequired
            name="user[company][city]"
            onValidateForm={onValidateForm}
            reactOnChange
            value={company?.city}
            disabled={isDisableField}
          />
        </Field>

        <Field label={strings[`${formPrefix}.region`]}>
          <TextInput
            isLatin
            name="user[company][state]"
            onValidateForm={onValidateForm}
            reactOnChange
            value={company?.state}
            disabled={isDisableField}
          />
        </Field>
      </PaymentBlockFields>
    </PaymentBlock>
  )
}

export default DI(['common', 'geodata', 'user'])(PaymentBilling)
